import { Divider, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useConfig } from "../../data/useConfig";
import { useFilters } from "../../data/useFilters";
import { useSearchResults } from "../../data/useSearchResults";
import { TitleContainer } from "./styles";
import TitleSkeleton from "../Skeleton/TitleSkeleton";

const default_tpl_term =
  '<h1>Pesquisando por "{{termo pesquisado}}".</h1><small>Encontramos {{total resultados}} resultados.</small>';

const default_tpl_anchor =
  "<h1>Tudo em {{nomes das classificações}}.</h1><small>{{total resultados}} produtos disponíveis.</small>";

const default_tpl_term_anchored =
  '<h1>Pesquisando "{{termo pesquisado}}" em {{nomes das classificações}}.</h1><small>{{total resultados}} disponíveis.</small>';

const ANCHOR = "anchor";
const TERM = "term";
const TERM_ANCHORED = "term_anchored";

const Title = ({ isMobile = false }) => {
  const { titleConfigs } = useConfig();
  const [fullTitle, setFullTitle] = useState("");

  const { data } = useSearchResults();
  const { isLoading: isLoadingFilters } = useFilters();

  const getSearchTypes = (types = []) => {
    if (types.includes(TERM) && types.includes(ANCHOR)) return TERM_ANCHORED;
    else if (types.includes(ANCHOR)) return ANCHOR;
    else return TERM;
  };

  const getTitleTpl = (type) => {
    if (type === TERM) return titleConfigs?.tpl?.term || default_tpl_term;
    if (type === ANCHOR) return titleConfigs?.tpl?.anchor || default_tpl_anchor;
    if (type === TERM_ANCHORED)
      return titleConfigs?.tpl?.["term-anchored"] || default_tpl_term_anchored;
  };

  const getResultsCount = (meta) => {
    if (
      Array.isArray(meta.filters_applied) &&
      meta.filters_applied.length > 0 &&
      meta.filters_results_count
    ) {
      return meta.filters_results_count;
    } else return meta.results_count;
  };

  const getClassifications = (tplType, meta) => {
    if (tplType === ANCHOR || tplType === TERM_ANCHORED) {
      const classifications = meta.anchors_applied
        .map(({ name }) => name)
        .join(", ")
        .replace(/, ([^,]+)$/, " e $1");

      return classifications;
    }
    return;
  };

  const setDocumentTitle = (titleTag) => {
    const regex = /<[^>]*>([^<]+)<\/[^>]*>/g;
    const title = regex.exec(titleTag);

    if (title) {
      document.title = title[1];
    }
  };

  const getTitle = () => {
    if (data) {
      const tpl_type = getSearchTypes(data.meta.types);
      const title_tpl = getTitleTpl(tpl_type);

      const title = title_tpl
        .replace(`{{total resultados}}`, getResultsCount(data.meta))
        .replace(`{{termo pesquisado}}`, data.meta.term)
        .replace(
          `{{nomes das classificações}}`,
          getClassifications(tpl_type, data.meta)
        );

      setDocumentTitle(title);

      const frag = document
        .createRange()
        .createContextualFragment(title).childNodes;

      const normalizedFrag = Object.values(frag).filter(
        (c) => c.nodeName !== "#text"
      );

      const div = document.createElement("div");
      Object.values(normalizedFrag).map((c) => (div.innerHTML += c.outerHTML));

      setFullTitle(getClassifications(tpl_type, data.meta));

      const titleDiv = document.querySelector(".search__title");
      if (titleDiv) {
        titleDiv.innerHTML = div.innerHTML;
      }
    }
  };

  useEffect(() => {
    getTitle();
  }, [data]);

  if (isLoadingFilters) return <TitleSkeleton />;

  return (
    data && (
      <>
        <Tooltip title={fullTitle}>
          <TitleContainer className="search__title" />
        </Tooltip>
        {!isMobile && <Divider />}
      </>
    )
  );
};

export default Title;
